import bg38 from 'assets/img/bg/bg-38.png';
import bgLeft from 'assets/img/bg/bg-left-24.png';
import bgRight from 'assets/img/bg/bg-right-24.png';
import appStore from 'assets/img/icons/app-store.png';
import logo from 'assets/img/icons/logo.png';
import Button from 'components/base/Button';
import { useAppContext } from 'providers/AppProvider';
import { Card, Col, Form, Row } from 'react-bootstrap';

const Cta = () => {
  const { getThemeColor } = useAppContext();
  return (
    <section className="dark__bg-gray-1000 pb-10 overflow-hidden">
      <div className="container-small px-lg-7 px-xxl-3">
        <div
          className="position-absolute w-100 h-100 start-0 end-0"
          style={{
            bottom: '-350px',
            transform: 'skewY(-8deg)',
            background:
              'linear-gradient(102.27deg, #1C6C09 4.69%, #0B3D00 106.27%)'
          }}
        />
        {/* <div
          className="bg-holder"
          style={{
            backgroundImage: `url(${bgLeft})`,
            backgroundSize: 'auto',
            backgroundPosition: 'left center'
          }}
        /> */}
        {/* <div
          className="bg-holder"
          style={{
            backgroundImage: `url(${bgRight})`,
            backgroundSize: 'auto',
            backgroundPosition: 'right center'
          }}
        /> */}
        <Row className="justify-content-center">
          <Col xs={12} className="text-center">
            <Card className="py-md-9 px-md-13 border-0 z-1 shadow-lg">
              <div
                className="bg-holder"
                style={{
                  backgroundImage: `url(${bg38})`,
                  backgroundPosition: 'center',
                  backgroundSize: '100%'
                }}
              />

              <Card.Body className="position-relative">
                <img
                  className="img-fluid mb-5 d-dark-none"
                  src={logo}
                  width={260}
                  alt="..."
                />
                <img
                  className="img-fluid mb-5 d-light-none"
                  src={logo}
                  width={260}
                  alt="..."
                />
                <h1 className="fs-6 fs-sm-4 fs-lg-2 fw-bolder lh-sm mb-3">
                  Join
                  <span
                    style={{ color: getThemeColor('primary') }}
                    className="mx-2"
                  >
                    Mlas
                  </span>
                  Today
                </h1>
                {/* <Form className="d-flex gap-3 justify-content-center mb-3 px-xxl-15">
                  <Form.Control
                    type="email"
                    placeholder="Email"
                    id="ctaEmail1"
                  />
                  <Button variant="primary" type="submit">
                    Join
                  </Button>
                </Form> */}
                <div className="d-flex gap-3 justify-content-center mb-3 px-xxl-15">
                  <a
                    href="https://apps.apple.com/us/app/mlas/id6695743993"
                    target="_blank"
                    className="d-inline-block"
                    rel="noreferrer"
                  >
                    <img src={appStore} alt="app store" height={50} />
                  </a>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default Cta;
